export default {"src":"/_next/static/media/heart.bd35f3bb.svg","height":108,"width":160,"blurWidth":0,"blurHeight":0};